import React from "react";
import { Banners } from '../../Components/Banner/Banners.jsx';
import './BannersStandalonePage.less';

export class BannersStandalonePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            user: null,
            userChecked: false,
            loading: true,
            error: false,
        };

        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;

        // Dohvati session (za user filtriranje) i standalone banner podatke paralelno
        this.dataPromise = casino.utils.makeCancelablePromise(
            Promise.all([
                casino.repos.sessionRepo.get().catch(() => ({ igrac: null, sesijaId: null })),
                casino.repos.bannersStandaloneRepo.list()
            ])
        );
        this.dataPromise.promise.then(
            ([session, data]) => {
                if (!this._isMounted) return;
                this.setState({
                    data: data,
                    user: session.igrac || null,
                    userChecked: true,
                    loading: false
                });
            },
            () => {
                if (!this._isMounted) return;
                this.setState({ loading: false, error: true });
            }
        );
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.dataPromise && this.dataPromise.cancel) {
            this.dataPromise.cancel();
        }
    }

    render() {
        if (this.state.loading) {
            return (
                <div className="banner-standalone-skeleton">
                    <div className="skeleton-shimmer" />
                </div>
            );
        }

        if (this.state.error || !this.state.data) {
            return (
                <div className="banner-standalone-error">
                    Greška u dohvaćanju banera.
                </div>
            );
        }

        const data = this.state.data;

        return (
            <div className="banner-standalone-wrapper">
                <Banners
                bannersData={data.banners || []}
                brands={data.brands || {}}
                igraDana={data.igraDana || null}
                categories={data.categories || []}
                jackpots={data.jackpots || []}
                noveIgreBanner={data.noveIgreBanner || []}
                maradonaIgreBanner={data.maradonaIgreBanner || []}
                showKategorijaFn={() => {}}
                showPopUpFn={() => {}}
                absoluteBaseUrl="https://mcasino.supersport.hr"
                user={this.state.user || null}
                userChecked={this.state.userChecked || false}
                carouselResponsive
            />
            </div>
        );
    }
}
